import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Blogs from "./pages/Blogs";
import Om from "./pages/Om";

import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';


export default function App() {

  
  return (
    <>
    
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="blogs" element={<Blogs />} />
         
          <Route path="contact" element={<Contact />} />
          <Route path="om" element={<Om />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
    <button className="btn btn-primary">click here</button>  
    


    </> 
             
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

              